<template>
  <div>
    <el-container>
      <el-header>
        <el-row style="width: 1000px; margin: 5px auto 5px auto;">
          <el-col :span="12">
            <img src="./../../../assets/web/img/logo-pgj.png" alt="large" />
          </el-col>
          <el-col :span="12">
            <el-link icon="el-icon-s-home" href="/" style="float: right;">返回首页</el-link>
          </el-col>
        </el-row>
      </el-header>
      <el-main style="border-bottom: 1px solid rgb(238, 238, 238);border-top: 1px solid rgb(238, 238, 238); margin-bottom: 20px;">
        <el-row style="width: 1000px; margin: auto;">
          <el-col :span="16">
            <img src="./../../../assets/web/img/login-left.png"/>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card" style="width: 300px; margin-top: 30px;">
              <div slot="header" class="clearfix">
                <span>登录</span>
              </div>
              <el-form :model="loginParam" :rules="rules" ref="loginParam" label-position="right" size="medium">
                <el-form-item label="账号" prop="username" style="margin-top:-15px">
                  <el-input v-model="loginParam.username" placeholder="用户名、邮箱或手机号" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" style="margin-top:-10px">
                  <el-input v-model="loginParam.password" placeholder="密码" :show-password="true" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width: 100%;" @click="openVerify">提交</el-button>
                </el-form-item>
              </el-form>
              <div>
                <el-link href="/uaapx/user/registinit">用户注册</el-link>
                <el-link href="/uaapx/user/findPassword" style="float: right;">忘记密码?</el-link>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
      <el-footer>
        <div align="center" style="color: #666; font-size: 13px;;">
          <small>
           <!-- <i class="el-icon-phone-outline"></i>
            <span style="margin-right: 20px;">400-628-9911</span>-->
            <i class="el-icon-message"></i>
            <span>service@chinaeinv.cn</span>
          </small>
          <p>
            <small>瑞宏网友情提醒：本软件由北京瑞宏具身智能机器人科技有限公司开发运营，不是税务机关的官方软件</small>
          </p>
          <p>
            <small>鲁ICP备16002436号-1</small>
          </p>
          <span>
            <img src="./../../../assets/web/img/foot-btn-safe2.png" alt="Responsive image" />
          </span>
        </div>
      </el-footer>
    </el-container>
    <el-dialog title="请完成以下拼图验证" width="370px" :visible.sync="verifyVisible" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <Verify @success="handleLogin" :mode="'fixed'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }"
        ref="verify" />
    </el-dialog>
  </div>
</template>

<script>
import util from "@/libs/util.js";
import Verify from "@/components/captcha/Verify.vue";
import { AccountLogin } from "./../../../api/sys.login.js";
export default {
  components: {
    Verify
  },
  data() {
    return {
      // 登陆表单
      loginParam: {
        username: "",
        password: "",
      },
      verifyVisible: false,
      bah: "",
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
    };
  },
  mounted(){
    //绑定事件
    window.addEventListener('keydown',this.keyDown);
    
    if (document.location.hostname.endsWith("net")) {
      this.bah = "京ICP备18050386号-3";
    } else {
      this.bah = "鲁ICP备16002436号-1";
    }
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
		keyDown(e){
			//如果是回车则执行登录方法
			if(e.keyCode == 13){
				this.openVerify();
			}
		},
    openVerify() {
      this.$refs["loginParam"].validate((valid) => {
        if (valid) {
          this.verifyVisible = true;
        } else {
          this.$message.error("请填写正确的账号和密码");
          return false;
        }
      });
    },
    // 提交登录
    handleLogin(params) {
      this.verifyVisible = false;
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.loginParam.captchaVerification = params.captchaVerification;
      AccountLogin(this.loginParam)
        .then(res => {
          util.cookies.set("uuid", res.id);
          // 设置 vuex 用户信息
          this.$store.dispatch("admin/user/set", res, {
            root: true
          });
          this.$store.dispatch("admin/user/load");

					let redirect = this.$route.query.redirect;
					if (redirect != null && redirect != undefined) {
						window.location.href = decodeURIComponent(redirect);
					} else {
						window.location.href = "/";
					}
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
  }
};
</script>

<style >
.font-14 {
  font-size: 14px;
}
#verifyModal .modal-dialog {
  max-width: 340px !important;
  margin: 1.75rem auto;
}
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: ' ';
  width: 0px;
  margin-right: 0px;
}
</style>